<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-1">
<h1 class="title"><span class="bold">A Christmas Carol</span></h1>
<p class="subt2">Charles Dickens</p>
<div class="img_container1">
<img alt="image" src="images/logo.jpg"/></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_Title.vue?38d0bcd8